import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  content: {
    width: 460
  },
  imageWrapper: {
    padding: 20,
    maxHeight: '100vh',
    flex: 1
  },
  image: {
    borderRadius: 16,
    height: 'calc(100vh - 40px)',
    width: '100%',
    objectFit: 'cover'
  }
}))
